"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Player = _interopRequireDefault(require("./Player"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = {
  code: 'pageBreak',
  name: 'Page break',
  icon: /*#__PURE__*/_react["default"].createElement("i", {
    className: "glyphicon glyphicon-minus"
  }),
  player: _Player["default"],
  isStaticPlayer: true,
  skipPlaying: true,
  previewButtons: ['delete']
};
exports["default"] = _default;